module.exports = __webpack_public_path__ + "img/home-arguments-todo.068fe115.svg";